module.exports = __webpack_public_path__ + "img/seminar_member_macbook.74bd7e2b.jpg";